require("!!/tmp/build/src/node_modules/script-loader/addScript.js")(require("!!/tmp/build/src/node_modules/raw-loader/index.js!/tmp/build/src/node_modules/zepto/dist/zepto.js"))

/*** EXPORTS FROM exports-loader ***/
module.exports = window.Zepto;